import { render, staticRenderFns } from "./AccessLink.vue?vue&type=template&id=264b41fa&lang=pug&"
import script from "./AccessLink.vue?vue&type=script&lang=js&"
export * from "./AccessLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports